/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const authAPI = {
  login: async (email, password) => {
    const { data } = await apiClient.post('/auth/login', { email, password });
    return data;
  },

  me: async () => {
    const { data } = await apiClient.get('/auth/me');
    return data;
  },

  logout: () => {
    localStorage.removeItem('tce_token');
    localStorage.removeItem('tce_user');
  },
};
